import { useStaticQuery, graphql } from 'gatsby';

import type { TMinimalTranslation } from '@klaviyo-mkt/marketing-cms/src/staticTypes';

import type { ISiteSettings } from '../../types';
import { formatHreflang } from './formatHreflang';

// These are rank ordered
const xDefaults = [
  'en-us',
  'en-gb',
];

// Only format hreflang for main klaviyo.com domain, not subdomains like help.klaviyo.com or academy.klaviyo.com
const isMainDomain = (siteUrl?: string): boolean => {
  if (!siteUrl) return false;
  try {
    const hostname = new URL(siteUrl).hostname;
    return hostname === 'klaviyo.com' || hostname === 'www.klaviyo.com';
  } catch {
    return false;
  }
};

export const HrefLang = ({
  noIndexNoFollow = false,
  siteUrl,
  translations = [],
}: {
  noIndexNoFollow?: boolean;
  siteUrl?: string;
  translations?: TMinimalTranslation[];
}) => {
  const data: ISiteSettings = useStaticQuery(graphql`
    query HrefLangQuery {
      wp {
        sites {
          hreflang
          includeInHfrelangTags
        }
      }
    }
  `);

  const exclusions = data?.wp?.sites?.map(({ includeInHfrelangTags, hreflang }) => includeInHfrelangTags === false ? hreflang : '').filter(Boolean) || [];
  const filteredTranslations = translations.filter(({ hreflang }) => !exclusions.includes(hreflang));
  const xDefault = filteredTranslations.find(({ hreflang }) => xDefaults.includes(hreflang));

  if (noIndexNoFollow) {
    return null;
  }

  const shouldFormat = isMainDomain(siteUrl);

  return (
    <>
      {filteredTranslations.map(({ hreflang, url }) => (
        <link key={hreflang} rel="alternate" href={url} hrefLang={shouldFormat ? formatHreflang(hreflang) : hreflang} />
      ))}
      {xDefault && (
        <link rel="alternate" hrefLang="x-default" href={xDefault.url} />
      )}
    </>
  );
};
